(function () {
  if (window.DrboProductNavigation) return;

  var legacyKinds = {
    "[data-section-type='product']": 'purchase',
    "[id$='__column_image']": 'overview',
    "[id*='embedded_advantages']": 'overview',
    '#specifications': 'specifications',
    "[id*='faq']": 'faq',
    "[id*='review']": 'reviews'
  };
  var headingPatterns = {
    specifications: /^(?:technische (?:daten|spezifikationen|übersicht|merkmale|hinweise)|technical (?:specifications|data|overview|features|notes)|APsystems EZ1-M technical specifications|set specifications|general specifications|allgemeine spezifikationen|specifications|produktdetails|product details|anschlüsse auf einen blick|connections at a glance|speicherkapazität und systemleistung|storage capacity and system output)(?:\b|[:：])/i,
    faq: /^(?:faq|faqs|häufige fragen|häufig gestellte fragen|fragen und antworten|frequently asked questions|frequent questions|common questions|questions to consider before choosing)(?:\b|[:：])/i
  };

  function textOf(element) {
    return (element && element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function selectable(element) {
    if (!element || !element.isConnected) return false;
    for (var ancestor = element; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
      var style = getComputedStyle(ancestor);
      if (ancestor.hidden || ancestor.getAttribute('aria-hidden') === 'true' || ancestor.hasAttribute('inert') || style.display === 'none' || style.visibility === 'hidden') return false;
    }
    var bounds = element.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0 || Boolean(element.closest('details:not([open])'));
  }

  function followingContent(heading, boundary) {
    var current = heading;
    while (current && current !== boundary) {
      if (current.nextElementSibling) {
        var sibling = current.nextElementSibling;
        return Boolean(textOf(sibling) || sibling.querySelector('img, video, table'));
      }
      current = current.parentElement;
    }
    return false;
  }

  function descriptionHeading(description, kind) {
    if (!description) return null;
    var candidates = Array.from(description.querySelectorAll('h1,h2,h3,h4,h5,h6,p'));
    return candidates.find(function (candidate) {
      if (candidate.tagName === 'P' && !candidate.querySelector('strong,b')) return false;
      var text = textOf(candidate);
      return text.length < 180 && headingPatterns[kind].test(text) && followingContent(candidate, description) && selectable(candidate);
    }) || null;
  }

  function create(root, onLayoutChange) {
    var main = root.closest('main') || document.querySelector('main');
    var tabs = Array.from(root.querySelectorAll('[data-sticky-nav-target]'));
    var targets = new Map();
    var refreshTimer;
    var cancelScroll = function () {};
    var destroyed = false;

    function query(selector, scope) {
      try {
        return Array.from((scope || main).querySelectorAll(selector)).find(selectable) || null;
      } catch (error) {
        return null;
      }
    }

    function contentSection(selector, contentSelector) {
      var section = query(selector);
      return section && Array.from(section.querySelectorAll(contentSelector)).some(function (content) { return textOf(content); }) ? section : null;
    }

    function resolve(tab) {
      if (!main) return null;
      var selector = tab.dataset.stickyNavTarget || '';
      var kind = legacyKinds[selector.replace(/"/g, "'")];
      var product = query('[data-section-type="product"]');
      var description = product && query('.product-description-wrapper', product);
      var target = null;
      if (kind === 'purchase') target = product;
      else if (kind === 'overview') target = description && textOf(description) ? description : contentSection("[id$='__embedded_advantages']", 'h2,h3');
      else if (kind === 'specifications') target = contentSection('[data-current-product-specifications]', 'table,ul,dl,p') || descriptionHeading(description, kind) || contentSection('#specifications', 'table,ul,dl,p');
      else if (kind === 'faq') target = contentSection('[data-current-product-faq]', 'p,ul,dl') || descriptionHeading(description, kind) || contentSection('.drbo-ac-faq', 'details');
      else if (kind === 'reviews') {
        target = contentSection('.drbo-base-reviews', '.drbo-base-reviews__quote')
          || contentSection('.drbo-proof', '.drbo-proof__quote')
          || contentSection('.jdgm-rev-widg', '.jdgm-rev__body');
      } else {
        target = query(selector);
        if (target && (!textOf(target) || root.contains(target))) target = null;
      }
      if (!target) return null;
      if (!target.id) {
        var anchorId = root.id + '-target-' + (kind || tabs.indexOf(tab));
        var suffix = 1;
        while (document.getElementById(anchorId)) anchorId = root.id + '-target-' + (kind || tabs.indexOf(tab)) + '-' + suffix++;
        target.id = anchorId;
      }
      if (kind) target.dataset.drboProductAnchor = kind;
      return target;
    }

    function refresh() {
      if (destroyed) return;
      var changed = false;
      tabs.forEach(function (tab) {
        var target = resolve(tab);
        targets.set(tab, target);
        if (tab.hidden === Boolean(target)) {
          tab.hidden = !target;
          changed = true;
        }
        if (target) {
          if (tab.getAttribute('aria-controls') !== target.id) tab.setAttribute('aria-controls', target.id);
          tab.dataset.stickyNavResolvedTarget = '#' + target.id;
        } else {
          tab.removeAttribute('aria-controls');
          tab.removeAttribute('aria-current');
          delete tab.dataset.stickyNavResolvedTarget;
          tab.classList.remove('is-active');
        }
      });
      root.dataset.navigationReady = 'true';
      if (changed && onLayoutChange) onLayoutChange();
    }

    function scheduleRefresh() {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, 120);
    }

    function offset() {
      var style = getComputedStyle(root);
      var top = parseFloat(style.getPropertyValue(window.innerWidth >= 768 ? '--drbo-sticky-top-desktop' : '--drbo-sticky-top-mobile')) || 0;
      var covered = Math.max(0, top) + root.getBoundingClientRect().height;
      document.querySelectorAll('header, [data-section-type="header"]').forEach(function (header) {
        var bounds = header.getBoundingClientRect();
        if (bounds.width < window.innerWidth / 2 || bounds.top < -1 || bounds.top > covered || bounds.bottom > window.innerHeight / 2) return;
        for (var ancestor = header; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
          if (/^(fixed|sticky)$/.test(getComputedStyle(ancestor).position)) {
            covered = Math.max(covered, bounds.bottom);
            break;
          }
        }
      });
      return covered + Number(root.dataset.scrollOffset || 0);
    }

    function scrollTo(tab) {
      cancelScroll();
      refresh();
      var target = targets.get(tab);
      if (!target) return;
      if (target.tagName === 'DETAILS') target.open = true;
      var details = target.parentElement && target.parentElement.closest('details');
      while (details) {
        details.open = true;
        details = details.parentElement && details.parentElement.closest('details');
      }
      tabs.forEach(function (item) {
        item.classList.toggle('is-active', item === tab);
        if (item === tab) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
      var hadTabindex = target.hasAttribute('tabindex');
      if (!hadTabindex) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (!hadTabindex) target.addEventListener('blur', function () { target.removeAttribute('tabindex'); }, { once: true });

      function destination() {
        var desired = window.scrollY + target.getBoundingClientRect().top - offset();
        return Math.max(0, Math.min(desired, document.documentElement.scrollHeight - window.innerHeight));
      }

      var settleTimer;
      var expiryTimer;
      var cancelled = false;
      var resizeObserver;
      function stop() {
        cancelled = true;
        window.clearTimeout(settleTimer);
        window.clearTimeout(expiryTimer);
        if (resizeObserver) resizeObserver.disconnect();
        window.removeEventListener('scroll', settle);
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (eventName) { window.removeEventListener(eventName, stop, true); });
      }
      function realign() {
        if (cancelled || !selectable(target)) return;
        var top = destination();
        if (Math.abs(window.scrollY - top) > 3) {
          window.scrollTo({ top: top, behavior: 'instant' });
        }
      }
      function settle() {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(realign, 220);
      }
      cancelScroll = stop;
      window.addEventListener('scroll', settle, { passive: true });
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (eventName) { window.addEventListener(eventName, stop, { passive: true, capture: true }); });
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(settle);
        resizeObserver.observe(main);
      }
      expiryTimer = window.setTimeout(function () { realign(); stop(); }, 3500);
      window.scrollTo({ top: destination(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      settle();
    }

    var observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return !root.contains(mutation.target); })) scheduleRefresh();
    });
    if (main) observer.observe(main, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleRefresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
    document.addEventListener('shopify:section:unload', scheduleRefresh);
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
    refresh();
    return {
      refresh: refresh,
      scrollTo: scrollTo,
      destroy: function () {
        destroyed = true;
        cancelScroll();
        window.clearTimeout(refreshTimer);
        observer.disconnect();
        window.removeEventListener('resize', scheduleRefresh);
        document.removeEventListener('DOMContentLoaded', refresh);
        document.removeEventListener('shopify:section:load', scheduleRefresh);
        document.removeEventListener('shopify:section:unload', scheduleRefresh);
      }
    };
  }

  window.DrboProductNavigation = { create: create };
  document.dispatchEvent(new Event('drbo:product-navigation:ready'));
}());
